import { createSlice } from "@reduxjs/toolkit"

export const auditUrl='/audit.json'
export interface auditInfo{
   timestamp: number,
   user: string,
   ip: string,
   type: string,
   id: string,
   desc: string,
   secondary_id: string,
   secondary_desc: string,
   operation:string,
   result: string,
   action:string,
   field: string,
   previous: string,
   previous_desc:string,
   current: string
   current_desc:string
}
export interface AuditHolder{
  entries:auditInfo[],
  total:number,
  limit:number
  offset:number,
  hasMore:boolean
}
const initialState : AuditHolder={
    entries:[],
    total: 0,
    limit: 0,
    offset: 0,
    hasMore: true
}
export const auditSlice=createSlice({
    name:'audit',
    initialState,
    reducers:{
        setAuditData:(state, action:{payload:AuditHolder})=>{
            state.entries = action.payload?.entries || [];
            state.total = action.payload?.total ?? 0;
            state.limit = action.payload?.limit ?? 0;
            state.offset = action.payload?.offset ?? 0;
            state.hasMore = action.payload?.hasMore ?? false;
        }
    }
})

// MW light (ticket #91, §2.7). /audit.json answers with the machine name; the
// grid shows a sentence. Anything not listed falls through to the raw value, so
// a new server-side operation still reads as itself rather than as blank.
const operationLabels: { [operation: string]: string } = {
  // A person pressed a button.
  checkout_request:		"Checkout requested",
  checkout_cancel:		"Checkout cancelled",
  // From the TV, with its IP, under the user `device`.
  checkout_ack:			"Checkout accepted by TV",
  checkout_done:		"Checkout done on TV",
  checkout_failed:		"Checkout failed on TV",
  checkout_unsupported:	"TV cannot clear apps",
  // Someone without the right tried.
  checkout_denied:		"Checkout denied",
};

export function auditOperationLabel(operation?: string): string {
  if (!operation)
    return "";

  return operationLabels[operation] || operation;
}

export default auditSlice.reducer;